import { render, staticRenderFns } from "./ProductAd.vue?vue&type=template&id=5a2c17d2&"
import script from "./ProductAd.vue?vue&type=script&lang=js&"
export * from "./ProductAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports